import type { FlowsTableFilter } from '../types/pipesList.types';

export const filterLabelMapping = {
  from: 'From',
  to: 'To',
  direction: 'Direction',
  direct: 'Direct',
  systemId: 'System',
  endpointType: 'Endpoint type',
  path: 'Includes',
  lastRunStatus: 'Last run',
};

export const emptyFilterFlows: FlowsTableFilter = {
  from: {
    selected: [],
    search: [],
  },
  to: {
    selected: [],
    search: [],
  },
  direction: {
    selected: [],
    search: [],
  },
  systemId: {
    selected: [],
    search: [],
  },
  endpointType: {
    selected: [],
    search: [],
  },
  direct: {
    selected: [],
    search: [],
  },
  path: {
    selected: [],
    search: [],
  },
  lastRunStatus: {
    selected: [],
    search: [],
  },
} as const;

export const defaultVisibleCols = [
  'From',
  'To',
  'Path',
  'System',
  'Endpoint type',
  'Direction',
  'Direct',
  'Queues',
  'Last run',
];

export const defaultSortBy = [
  {
    id: 'flows-from',
    desc: false,
  },
];

export const defaultVisibleFacets = ['from', 'to', 'system', 'direct'];

export const getFlowsDefaultFilter = (filters: FlowsTableFilter) => ({
  ...filters,
  from: { ...filters.from, selected: [] },
});

export const flowsFilters = getFlowsDefaultFilter(emptyFilterFlows);
